// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import {
    chain,
    DispatchSetInitialValues,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";

export const XngDispatchSetInitialValues: typeof DispatchSetInitialValues = (props: any) => {
    const account = getCurrentAccountState(props.getState()).value;
    if (!account) {
        throw new Error("There was no current account when we are trying to save the current account");
    }

    props.dispatch({
        type: "Pages/xAccountSettings/SetInitialValues",
        properties: {
            billTrustEmailConfirmations: account?.properties?.billTrustEmailConfirmations,
            billTrustEmailNotify: account?.properties?.billTrustEmailNotify,
            billTrustPdfAttachment: account?.properties?.billTrustPdfAttachment,
        },
    });
};

addToChainAfter(chain, DispatchSetInitialValues, XngDispatchSetInitialValues);
